import { render, staticRenderFns } from "./BlockButtonRounded.vue?vue&type=template&id=5d6fe6a6&scoped=true"
import script from "./BlockButtonRounded.vue?vue&type=script&lang=js"
export * from "./BlockButtonRounded.vue?vue&type=script&lang=js"
import style0 from "./BlockButtonRounded.vue?vue&type=style&index=0&id=5d6fe6a6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6fe6a6",
  null
  
)

export default component.exports